export default [{
  label: 'Razão social', field: 'razaoSocial', type: 'custom',
},
{ label: 'CNPJ/CPF', field: 'cadastroFederal', tdClass: 'col-tamanho-cnpj' },
{ label: 'Estado', field: 'estado' },
{ label: 'Situação', field: 'situacao', type: 'custom' }, // reguar ou irregular
{ label: 'Consultado em', field: 'ultimaConsulta', thClass: 'col-nowrap' },
{ label: 'Próxima consulta', field: 'proximaConsulta', type: 'custom' },
{ label: 'Data da validade', field: 'validade' }]
